import {
  Column,
  Row
} from "hedron";
import * as React from "react";
import styled, { keyframes } from "styled-components";

import { colourHelper } from "../../theme/theme-helper";
import { MediumColumnWidthWrapper } from "../confines-wrappers";
import Icon from "../icon/icon";
import Link from "../link";
import Text from "../text";

interface ITag {
  node: {
    name: string;
    path: {
      alias: string;
    };
  };
}

interface IProps {
  tags: ITag[];
  root: string;
  rootTerm: string;
}

interface IState {
  visible: boolean;
  collapse: boolean;
}

const initialState: IState = {
  visible: false,
  collapse: true
};

const Tags = styled(Row)`
  width: 100%;
  margin: 30px 0 50px 0;
`;

const Tag = styled(Column)`
  padding-top: 10px;
  a {
    text-decoration: none;
    color: inherit;
    padding-bottom: 6px;

    &:hover {
      color: ${({ theme }) => colourHelper({
    theme,
    variant: "brandColor"
  })};
    }

    &.active {
      color: ${({ theme }) => colourHelper({
    theme,
    variant: "brandColor"
  })};
      border-bottom: 2px solid
        ${({ theme }) => colourHelper({
    theme,
    variant: "brandColor"
  })}80;
    }
  }
`;

const SlideIn = keyframes`
  to {
    transform: translateY(0)
  }
`;

const Collapse = styled.nav`
  position: fixed;
  width: 100%;
  display: flex;
  padding: 15px 0;
  justify-content: center;
  background-color: ${({ theme }) =>
    colourHelper({
      theme,
      variant: "altLightGrey"
    })};
  z-index: 99;

  transition: all 0.3s ease-in-out;
  transform: translateY(-100%);
  animation: ${SlideIn} ease-in-out 0.2s forwards;

  .icon {
    cursor: pointer;
  }
`;

const CollapsedTags = styled.div``;

const Overlay = styled.div`
  height: 100vh;
  position: fixed;
  width: 100%;
  background-color: ${({ theme }) =>
    colourHelper({
      theme,
      variant: "altLightGrey"
    })}90;
  z-index: -1;
  top: 0;
  left: 0;
`;

const CloseTags = styled.div`
  display: flex;
  padding: 30px 0;
  justify-content: center;

  .icon {
    margin: 0 10px;
  }
`;

class CollapseTags extends React.Component<IProps> {
  public readonly state: IState = initialState;

  public componentDidMount() {
    window.addEventListener("scroll", () => this.handleScroll());
  }

  public render() {
    const {
      root, rootTerm, tags
    } = this.props;

    const { visible, collapse } = this.state;
    let navDom: HTMLElement | null = null;

    // Fixes build issue
    if (typeof document === "undefined" || !visible) {
      return null;
    }

    // Set the navDom
    navDom = document.getElementById("navigation-container");

    return (
      <Collapse style={{ top: navDom ? navDom.offsetHeight : 0 }}>
        {collapse ? (
          <CollapsedTags onClick={() => this.toggleCollapse()}>
            <Icon
              className="icon"
              icon="tags"
              size={1.5}
            />
          </CollapsedTags>
        ) : (
          <>
            <Overlay />

            <MediumColumnWidthWrapper>
              <Tags
                tagName="ul"
                divisions={10}
              >
                <Tag
                  tagName="li"
                  fluid
                  divisions={10}
                  xs={5}
                  sm={2}
                >
                  <Text fontSize="body_1">
                    <Link
                      type="none"
                      activeClassName="active"
                      href={root}
                    >
                      {rootTerm}
                    </Link>
                  </Text>
                </Tag>

                {tags.map((tag: ITag, index: number) => (
                  <Tag
                    tagName="li"
                    fluid
                    divisions={10}
                    xs={5}
                    sm={2}
                    key={index}
                  >
                    <Text fontSize="body_1">
                      <Link
                        type="none"
                        activeClassName="active"
                        href={tag.node.path.alias}
                      >
                        {tag.node.name}
                      </Link>
                    </Text>
                  </Tag>
                ))}
              </Tags>

              <CloseTags onClick={() => this.toggleCollapse()}>
                <Icon
                  className="icon"
                  icon="tags"
                  size={1.5}
                />

                <Icon
                  className="icon"
                  icon="close"
                  size={1.5}
                />
              </CloseTags>
            </MediumColumnWidthWrapper>
          </>
        )}
      </Collapse>
    );
  }

  private toggleCollapse() {
    this.setState({ collapse: !this.state.collapse });
  }

  private handleScroll() {
    const navDom = document.getElementById("navigation-container");
    const heroDom = document.getElementById("hero");
    const windowPageYOffset: number = window.pageYOffset;
    let heroDomOffsetHeight = 0;
    let navDomOffsetHeight = 0;
    let navYOffset = 0;
    // let navHeroPageYOffsetPercentage: number = 0;

    // If there is a hero DOM, work out the scrollTop and compare it to the
    // hero's height and set state accordingly
    if (navDom && heroDom) {
      heroDomOffsetHeight = heroDom.offsetHeight;
      navDomOffsetHeight = navDom.offsetHeight;
      navYOffset = heroDomOffsetHeight - navDomOffsetHeight;

      if (windowPageYOffset >= navYOffset) {
        this.setState({ visible: true });
      } else {
        this.setState({ visible: false });
      }
    } else {
      this.setState({ visible: false });
    }
  }
}

export default CollapseTags;
